import React from 'react';
import { MARQUEE } from '../../data/ribbonData';

export const RibbonMarquee = () => (
  <div className="relative bg-gradient-to-r from-[#ff8a00] via-[#ff4d00] to-[#ff8a00] text-black overflow-hidden py-4 -rotate-1 my-6 shadow-[0_0_40px_rgba(255,106,0,0.6)]" data-testid="ribbon-marquee">
    <div className="flex w-max en-marquee-track">
      {[...MARQUEE, ...MARQUEE, ...MARQUEE, ...MARQUEE].map((t, i) => (
        <span key={i} className="flex items-center gap-6 px-6 rb-head text-2xl sm:text-3xl whitespace-nowrap [text-shadow:none]">
          {t} <span className="text-white">✦</span>
        </span>
      ))}
    </div>
  </div>
);
